import { useContext } from "react";
import { AppContext } from "@/App";
import { Crown, Phone, Mail, MessageCircle, CarFront } from "lucide-react";

export default function Footer() {
  const { t } = useContext(AppContext);
  return (
    <footer id="contatti" className="border-t border-[rgba(212,175,55,0.15)] bg-[#0D0F12]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div
          data-testid="driver-app-teaser-banner"
          className="card-surface mb-16 flex flex-col items-start justify-between gap-6 !border-[rgba(212,175,55,0.4)] p-8 sm:flex-row sm:items-center"
        >
          <div className="flex items-start gap-4">
            <div className="rounded-full border border-[rgba(212,175,55,0.4)] p-3">
              <CarFront className="h-6 w-6 text-[#D4AF37]" />
            </div>
            <div>
              <h3 className="font-display text-2xl font-semibold text-white">{t.driverTeaser.title}</h3>
              <p className="mt-1 text-sm text-neutral-400">{t.driverTeaser.sub}</p>
            </div>
          </div>
          <a href="mailto:R.p.companyservice@gmail.com" data-testid="driver-apply-btn" className="btn-gold shrink-0">
            <Mail className="h-4 w-4" />
            {t.driverTeaser.cta}
          </a>
        </div>

        <div className="flex flex-col justify-between gap-10 md:flex-row">
          <div>
            <div className="flex items-center gap-2">
              <Crown className="h-5 w-5 text-[#D4AF37]" />
              <span className="font-display text-lg font-semibold text-white">
                R.P. <span className="text-[#D4AF37]">Limousine</span> Milano
              </span>
            </div>
            <p className="mt-3 max-w-xs text-sm text-neutral-400">{t.footer.tagline}</p>
            <p className="mt-2 font-code text-xs uppercase tracking-widest text-neutral-500">{t.footer.hours}</p>
          </div>
          <div>
            <p className="label-accent mb-4 !text-[10px]">05 — {t.footer.contacts}</p>
            <div className="space-y-3 text-sm">
              <a href="tel:+393482215105" data-testid="footer-phone-link" className="flex items-center gap-2.5 text-neutral-300 transition-colors hover:text-[#E5C158]">
                <Phone className="h-4 w-4 text-[#D4AF37]" /> +39 348 221 5105
              </a>
              <a href="mailto:R.p.companyservice@gmail.com" data-testid="footer-email-link" className="flex items-center gap-2.5 text-neutral-300 transition-colors hover:text-[#E5C158]">
                <Mail className="h-4 w-4 text-[#D4AF37]" /> R.p.companyservice@gmail.com
              </a>
              <a href="https://wa.me/393482215105" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-2.5 text-neutral-300 transition-colors hover:text-[#25D366]">
                <MessageCircle className="h-4 w-4 text-[#25D366]" /> WhatsApp 24/7
              </a>
            </div>
          </div>
        </div>

        <p className="mt-14 border-t border-[rgba(212,175,55,0.1)] pt-6 text-xs text-neutral-600">{t.footer.legal}</p>
      </div>
    </footer>
  );
}
